export default "__VITE_ASSET__B_NUa$zZ__"